import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Automatically scrolls to top when route changes
export default function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // no animation, instant scroll
    });
  }, [pathname]);
}